const THEME_STORAGE_KEY = 'theme';

export function getStoredTheme(): string | null {
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);

    if (!stored || stored.trim() === '') {
      return null;
    }

    return stored;
  } catch {
    return null;
  }
}

export function setStoredTheme(themeId: string): void {
  try {
    if (!themeId || themeId.trim() === '') {
      return;
    }

    localStorage.setItem(THEME_STORAGE_KEY, themeId);
  } catch {
  }
}

export function clearStoredTheme(): void {
  try {
    localStorage.removeItem(THEME_STORAGE_KEY);
  } catch {
  }
}
